import { render, staticRenderFns } from "./SimpleInfographicCard.vue?vue&type=template&id=e5d0bd66&scoped=true"
import script from "./SimpleInfographicCard.vue?vue&type=script&lang=js"
export * from "./SimpleInfographicCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleInfographicCard.vue?vue&type=style&index=0&id=e5d0bd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d0bd66",
  null
  
)

export default component.exports